module.exports = __webpack_public_path__ + "img/65.b04fba3d.gif";